import { Autocomplete, TextField, FormControl, FormLabel } from "@mui/material";
import { useMemo, useState } from "react";

const DropdownMultiSelect = ({
  options = [],
  label,
  selectedValue = [], // ✅ must be an array for multi-select
  onSelect,
  error,
  ...rest
}) => {
  const [inputValue, setInputValue] = useState("");

  const handleChange = (event, newValue) => {
    onSelect(newValue); // ✅ newValue is an array
  };

  const handleInputChange = (event, newValue) => {
    setInputValue(newValue || "");
  };

  const filteredOptions = useMemo(() => {
    return inputValue
      ? options.filter((option) =>
          option?.label?.toLowerCase()?.includes(inputValue?.toLowerCase())
        )
      : options;
  }, [inputValue, options]);

  return (
    <FormControl fullWidth error={Boolean(error)} {...rest}>
      <FormLabel
        component="legend"
        style={{ color: error ? "red" : "inherit" }}
      >
        {error || label}
      </FormLabel>
      <Autocomplete
        multiple // ✅ enable multiple selection
        options={filteredOptions}
        size="small"
        value={selectedValue}
        onChange={handleChange}
        inputValue={inputValue}
        onInputChange={handleInputChange}
        getOptionLabel={(option) => option?.label || ""}
        isOptionEqualToValue={(option, value) => option.value === value.value} // ✅ compare correctly
        disableCloseOnSelect
        renderInput={(params) => (
          <TextField
            variant="outlined"
            {...params}
            error={Boolean(error)}
            InputLabelProps={{ shrink: true }}
          />
        )}
      />
    </FormControl>
  );
};

export default DropdownMultiSelect;
